export { default, default as SimpleGrid } from './SimpleGrid'
export * as SimpleGridStyles from './styles/SimpleGrid.style'

export type { SimpleGridProps, Layout, LayoutColumn } from './SimpleGrid.types'
export type { StyledSimpleGridProps } from './styles/SimpleGrid.style.types'
